import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getCardiacSelector } from '../selectors'
import { setAddToTimeLine, setSaveResponse } from '../store/cardiac.actions'
import { CardiacConstants } from '../store/cardiac.constants'
import { ICardiacState } from '../store/cardiac.types'
import { getCardiacFilters } from '../utilities/saveCardiac.util'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { addCardiacItem } from '../../../timeline/store/timeline.actions'
import { getServiceIdSelector } from '../../../user/selectors'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveCardiac() {
  const cardiacStateWithDefaults: ICardiacState = yield select(getCardiacSelector)
  let cardiacState: ICardiacState = {
    ...cardiacStateWithDefaults,
    cardiacDefaults: null,
  }

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    cardiacState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: cardiacState,
      actionField: (s) => s.action?.name,
      nemsisCodeOptions,
      ...getCardiacFilters(cardiacState),
    })
  } catch (error: unknown) {
    cardiacState = handleNemsisCodeError(error, cardiacState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.cardiacStateList && pcrDoc.patient?.cardiacStateList.length) {
    const index = pcrDoc.patient?.cardiacStateList?.findIndex((cardiac) => cardiac.key === cardiacState.key)
    if (index !== -1) {
      pcrDoc.patient.cardiacStateList[index] = cardiacState
    } else {
      pcrDoc.patient?.cardiacStateList.push(cardiacState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, cardiacStateList: [cardiacState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    const saveResponse: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(setSaveResponse(saveResponse))
    yield put(addCardiacItem())
  } catch (e) {
    yield put(throwPcrException(`saveCardiac() error: ${e}`))
  }
}

export function* saveCardiacSaga() {
  yield takeLatest(
    [
      CardiacConstants.SAVE_CARDIAC,
      CardiacConstants.SET_DATE,
      CardiacConstants.SET_TIME,
      CardiacConstants.SET_DATE_TIME,
      CardiacConstants.SET_ASSESSED_BY,
      CardiacConstants.SET_RESPONSE,
      CardiacConstants.SET_RESPONSE_PNNV,
      CardiacConstants.SET_PROCEDURE_COMPLICATIONS,
      CardiacConstants.SET_AUTHORIZATION,
      CardiacConstants.SET_LEAD_CHANGE,
      CardiacConstants.SET_ATTEMPTS,
      CardiacConstants.SET_ROLE_PERFORMING,
      CardiacConstants.SET_ROLE_PERFORMING_PNNV,
      CardiacConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      CardiacConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      CardiacConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveCardiac
  )
}
